import React from 'react';
import Map from './comps/Map';
import Current from './comps/Current';
import DropDownBox from './comps/droupdown/DropDownBox';

function App() {
  return <div>
    <Map/>
    <Current/>
    <DropDownBox/>
  </div>;
}

export default App;
